import Guid from "@/app/utils/guid"
import Nodes from '@/diagrams/utils/nodes'

export default class Node {

  public type: NodeType = 'node'
  public className: NodeClassName = 'Topic'
  public dbId = Guid.empty()

  constructor(
    type: NodeType = 'node',
    className: NodeClassName = 'Topic',
    dbId: string = Guid.empty()) {
    this.type = type
    this.className = className
    this.dbId = dbId
  }

  get isProject() {
    return Nodes.isProject(this.type)
  }

  get isTopic() {
    return Nodes.isTopic(this.className)
  }

  get isTopicGroup() {
    return Nodes.isTopicGroup(this.className)
  }

  get isProjectStakeholder() {
    return Nodes.isProjectStakeholder(this.className)
  }

  get isProjectStakeholderGroup() {
    return Nodes.isProjectStakeholderGroup(this.className)
  }

  get isAction() {
    return Nodes.isAction(this.className)
  }

  get isActionGroup() {
    return Nodes.isActionGroup(this.className)
  }
}
